import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApiServices } from '../../../services/api-endpoints/useApiServices';
import { toast } from 'react-toastify';

const Login = () => {
  const api = useApiServices();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const FormHandler = async (event) => {
    event.preventDefault();
    setErrorMessage('');
    setIsLoading(true);
    try {
      const { result } = await api.LoginAsync({ username, password });
      if (result.isSuccess) {
        toast.success('ยินดีต้อนรับ');
        localStorage.setItem('accessToken', result.accessToken);
        localStorage.setItem('refreshToken', result.refreshToken);
        navigate('/dashboard');
      } else {
        setErrorMessage(result.message || 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง');
      }
    } catch (err) {
      setErrorMessage('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.logoArea}>
          <div style={styles.logoIcon}>
            <i className="fas fa-hard-hat" style={{ fontSize: 28, color: '#fff' }} />
          </div>
          <h2 style={styles.appName}>เพื่อนรับเหมา</h2>
          <p style={styles.appSubtitle}>Admin Portal</p>
        </div>

        <form onSubmit={FormHandler} style={styles.form}>
          {errorMessage && (
            <div style={styles.errorBox}>
              <i className="fa fa-exclamation-circle" style={{ marginRight: 8 }} />
              {errorMessage}
            </div>
          )}

          <div style={styles.inputGroup}>
            <label style={styles.label} htmlFor="login-username">ชื่อผู้ใช้</label>
            <div style={styles.inputWrapper}>
              <i className="fa fa-user" style={styles.inputIcon} />
              <input
                id="login-username"
                type="text"
                placeholder="กรอกชื่อผู้ใช้"
                style={styles.input}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                required
                disabled={isLoading}
              />
            </div>
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label} htmlFor="login-password">รหัสผ่าน</label>
            <div style={styles.inputWrapper}>
              <i className="fa fa-lock" style={styles.inputIcon} />
              <input
                id="login-password"
                type={showPassword ? 'text' : 'password'}
                placeholder="กรอกรหัสผ่าน"
                style={{ ...styles.input, paddingRight: 44 }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
                disabled={isLoading}
              />
              <button
                type="button"
                style={styles.togglePassword}
                onClick={() => setShowPassword(!showPassword)}
                tabIndex={-1}
              >
                <i className={`fa fa-${showPassword ? 'eye-slash' : 'eye'}`} />
              </button>
            </div>
          </div>

          <button
            type="submit"
            style={{ ...styles.submitBtn, opacity: isLoading ? 0.7 : 1 }}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span style={styles.spinner} />
                กำลังเข้าสู่ระบบ...
              </>
            ) : (
              'เข้าสู่ระบบ'
            )}
          </button>
        </form>

        <div style={styles.footer}>
          <p style={{ margin: 0, color: '#9ca3af', fontSize: 13 }}>
            Copyright &copy; 2025 เพื่อนรับเหมา.com
          </p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px 16px',
  },
  card: {
    background: '#fff',
    borderRadius: 16,
    boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
    width: '100%',
    maxWidth: 480,
    overflow: 'hidden',
  },
  logoArea: {
    background: 'linear-gradient(135deg, #1e3a5f 0%, #2d6a9f 100%)',
    padding: '36px 32px 28px',
    textAlign: 'center',
  },
  logoIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 64,
    height: 64,
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.2)',
    marginBottom: 12,
  },
  appName: {
    color: '#fff',
    fontSize: 24,
    fontWeight: 700,
    margin: '0 0 4px',
  },
  appSubtitle: {
    color: 'rgba(255,255,255,0.7)',
    fontSize: 14,
    margin: 0,
  },
  form: {
    padding: '28px 32px 20px',
  },
  errorBox: {
    background: '#fef2f2',
    border: '1px solid #fecaca',
    color: '#dc2626',
    borderRadius: 8,
    padding: '10px 14px',
    fontSize: 14,
    marginBottom: 20,
    display: 'flex',
    alignItems: 'center',
  },
  inputGroup: {
    marginBottom: 20,
  },
  label: {
    display: 'block',
    fontSize: 14,
    fontWeight: 600,
    color: '#374151',
    marginBottom: 6,
  },
  inputWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  inputIcon: {
    position: 'absolute',
    left: 14,
    color: '#9ca3af',
    fontSize: 14,
    pointerEvents: 'none',
  },
  input: {
    width: '100%',
    padding: '12px 14px 12px 40px',
    border: '1.5px solid #e5e7eb',
    borderRadius: 8,
    fontSize: 15,
    outline: 'none',
    transition: 'border-color 0.2s',
    boxSizing: 'border-box',
    lineHeight: '1.5',
  },
  togglePassword: {
    position: 'absolute',
    right: 12,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#9ca3af',
    padding: 4,
  },
  submitBtn: {
    width: '100%',
    padding: '13px',
    background: 'linear-gradient(135deg, #1e3a5f 0%, #2d6a9f 100%)',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    marginTop: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    transition: 'opacity 0.2s',
    minHeight: 48,
  },
  spinner: {
    display: 'inline-block',
    width: 16,
    height: 16,
    border: '2px solid rgba(255,255,255,0.4)',
    borderTopColor: '#fff',
    borderRadius: '50%',
    animation: 'spin 0.7s linear infinite',
  },
  footer: {
    padding: '16px 32px',
    textAlign: 'center',
    borderTop: '1px solid #f3f4f6',
  },
};

export default Login;
